module.exports = __webpack_public_path__ + "videos/recognition.gif.f4339ca.mp4";